import type { PostOfficeEnvironmentConfig } from '@atlassian/post-office-placement-remote';
import { environment as trelloEnvironment } from '@trello/config';
import { PersistentSharedState } from '@trello/shared-state';

export type PostOfficeEnvironment = Extract<
  PostOfficeEnvironmentConfig['env'],
  'local' | 'production' | 'staging' | 'test-server' | 'test'
>;

export const postOfficeEnvironmentInitialState: PostOfficeEnvironment =
  trelloEnvironment === 'prod' ? 'production' : 'staging';

export const postOfficeEnvironmentSharedState =
  new PersistentSharedState<PostOfficeEnvironment>(
    postOfficeEnvironmentInitialState,
    {
      storageKey: 'postOfficeEnvironment',
    },
  );

if (
  trelloEnvironment === 'prod' &&
  postOfficeEnvironmentSharedState.value !== 'production'
) {
  // oxlint-disable-next-line @trello/no-module-logic
  postOfficeEnvironmentSharedState.setValue('production');
}
